export default {
	service: ["サービス", "イベント", "出金", "入金", "利用規約", "証明書", "FAQ", "ユーザーガイド", "VIP"],
	sign: {
		title: "{0}日間サインイン",
		SignIn: "サインイン"
	},
	hotMusicAlbum: "ホットミュージックアルバム",
	hotMusic: "ホットソングチャート",
	popular: "新しいプレイ",
	rankings: "人気映画",
	top: "TOP{0}",
	OnchainServices: "オンチェーンサービス",
	Real: {
		title: "リアルタイム",
		list: [
			"オンラインユーザー総数",
			"ユーザーの平均最適化量",
			"最適化ニーズのヒートマップ",
			"プラットフォームプロモーション最適化量"
		]
	},
	Profit: {
		Profit: "利益",
		tabs: ["利益", "ボーナス", "アカウント"],
		TotalBalance: "総残高",
		TotalLuckyBonus: "総ラッキーボーナス",
		todayEarnings: "本日の収益",
		availableBalance: "利用可能残高",
		title: ["本日の収益", "総収益", "アカウント"],
		list: ["注文収益", "チーム収益", "総収益"],
		order: {
			title: "注文利益",
			commission: "注文手数料"
		},
		Analysis: {
			title: "利益分析",
			tips: "あなたは{0}件の取引を行いました",
			tabs: ["本日の利益", "総利益"],
			totalTitle: ["注文利益", "チェックイン利益", "チーム利益", "ボーナス利益"]
		}
	},
	CustomerService: {
		title: "カスタマーサービスセンター",
		consultation: "カスタマーサービス相談",
		btn: "お問い合わせ",
		noticeTitle: "システム通知"
	},
	addWallet: "ウォレットを追加",
	taskProgress: "日々のタスク進行状況",
	currentProgress: "現在のタスク進行状況",
	work: {
		title: "注文提出報酬",
		SignIn: "取得する"
	},
	awardsBulletin: `{0} ユーザーがタスクで {1} {2} 賞を獲得しました。`,
	vip: {
		title: "@:vip.title",
		more: "もっと見る"
	},
	stats: {
		title: "データソース - ダッシュボードとAPI",
		subTitle: "アーティストの統計",
		list: ["メトリック", "アクティブなソーシャルを持つアーティスト", "毎日更新"]
	}
};
